import { useEffect, useRef } from "react"
import { notifyBugsnag } from "@common/utils/initBugsnag"

/**
 * Une reprise que le serveur n'a pas servie, hors lien illisible : l'écran
 * propose « Réessayer », et personne d'autre ne le voyait. Le code HTTP dit quel
 * échec c'était : 429, 5xx, 0 quand le navigateur était hors ligne, absent
 * quand la requête est partie sans réponse (coupure, délai, CORS).
 */
export const reportResumeFailure = (funnel, error, { template } = {}) =>
    notifyBugsnag(new Error(`Reprise du funnel ${funnel} en échec`), {
        funnel,
        status: error?.status ?? null,
        message: error?.message ?? null,
        template: template ?? null,
        online: typeof navigator !== "undefined" ? navigator.onLine : null,
    })

/**
 * Signale chaque échec de reprise de cet écran. L'erreur trouvée au montage est
 * celle d'une visite précédente de l'onglet (le store la garde) : elle a déjà
 * été signalée.
 */
export const useResumeFailureReport = (funnel, error, { unreadable, template }) => {
    const errorAtMount = useRef(error)

    useEffect(() => {
        if (error && error !== errorAtMount.current && !unreadable)
            reportResumeFailure(funnel, error, { template })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [error])
}
